import { Chip, Tooltip } from "@mui/material";
import { REVIEW_STATUS, REVIEW_STATUS_UI } from "../../constants";

// Chip informativo (no clicable) de estado de revisión. Toda la apariencia
// sale del mapa único REVIEW_STATUS_UI; `prefix` antepone el nombre del
// componente (p. ej. "Actividades: Devuelta") y `tooltip` muestra el detalle.
const ReviewStatusChip = ({ status, prefix, tooltip, size = "small", sx }) => {
  const ui = REVIEW_STATUS_UI[status] || REVIEW_STATUS_UI[REVIEW_STATUS.PENDING];
  const { Icon } = ui;

  const chip = (
    <Chip
      size={size}
      icon={<Icon />}
      label={prefix ? `${prefix}: ${ui.label}` : ui.label}
      color={ui.color}
      variant="outlined"
      sx={{ ...ui.sx, ...sx }}
    />
  );

  if (!tooltip) return chip;
  return <Tooltip title={tooltip}>{chip}</Tooltip>;
};

export default ReviewStatusChip;
